export default __webpack_public_path__ + "static/media/twelve-week-sprint.82516601.pdf";